export enum WindowExposure {
  INTERNA = 'INTERNA',
  ESTERNA = 'ESTERNA',
  DOPPIA = 'DOPPIA',
}
